import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { ContinuousCourseOffering } from 'src/app/models/continuous-course-offering';
import { environment } from 'src/environments/environment';
import { catchError, map } from 'rxjs/operators';
import { ERROR_MESSAGES } from 'src/app/constants/error-messages';

@Injectable()
export class ContinuousCourseOfferingService {

  constructor(private readonly http: HttpClient) { }

  // TODO: Replace all "sync-element" usages (frontend + backend) with the new name "course-offering".
  // This includes API endpoints, services, models, and related DTOs.
  // Update the methods in this file once the backend endpoint is renamed.
  getContinuousCourseOfferings(courseId: number): Observable<ContinuousCourseOffering[]> {
    return this.http.get<ContinuousCourseOffering[]>(`${environment.apiUrl}/continuous-sync-elements/course/${courseId}`);
  }

  create(courseId: number, ce: ContinuousCourseOffering): Observable<boolean> {
    return this.http.post<void>(`${environment.apiUrl}/continuous-sync-elements/`, {
      courseEssenceId: courseId,
      revision: ce.revision,
      options: ce.options,
      hasChallengeOffering: ce.hasChallengeOffering
  }).pipe(
      map(() => true),
      catchError((err) => this.handleApiError(err))
    );
  }
  
  update(courseId: number, ce: ContinuousCourseOffering): Observable<boolean> {
    return this.http.patch<void>(`${environment.apiUrl}/continuous-sync-elements/`, {
        courseEssenceId: courseId,
        id: ce.id,
        revision: ce.revision,
        options: ce.options,
        hasChallengeOffering: ce.hasChallengeOffering
    }).pipe(
      map(() => true),
      catchError((err) => this.handleApiError(err))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/continuous-sync-elements/${id}`);
  }

  handleApiError(err: any): Observable<never> {
    let errorCode: string | undefined;
  
    if (Array.isArray(err?.error?.message)) {
      errorCode = err.error.message[0];
    }
  
    const message = ERROR_MESSAGES[errorCode ?? ''] || 'Something went wrong. Please try again.';
    return throwError(() => new Error(message));
  }
}
